import axios from "axios";

// In development (CRA dev server) we need the full backend URL because the
// React dev server runs on a different port. In production, the app is served
// on the same origin as the API (both preview URL and custom domain like
// mysavvy.in), so we use same-origin relative calls — this is what allows
// httpOnly auth cookies to work under SameSite=Lax on every domain the app
// is served from, without rebuilding per environment.
const isDev = process.env.NODE_ENV === "development";
const BACKEND_URL = isDev
  ? process.env.REACT_APP_BACKEND_URL
  : (typeof window !== "undefined" ? window.location.origin : "");

export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
